export const SpecialMentionDialogId = Object.freeze({
	allParticipants: 'all',
});
